import type {
  ProductListing,
  PlpDesignItem,
  PlpFilter,
  PlpFilterItem,
  ListingSeo,
  ListingFaqItem,
} from '../../domain/models/ProductListing';

export interface PlpDesignItemVm {
  designId: number;
  designName: string;
  imageUrl: string;
  hoverImageUrl?: string;
  productPageUrl: string;
  price: string;
  discountedPrice?: string;
  discountPercent?: number;
  discountOnDiamondPriceValue?: number;
  discountName?: string;
  discountValue?: string;
  customizationId?: number;
  videoUrl?: string;
  videoPosterUrl?: string;
  categoryType?: string;
  metal?: string;
  analyticsImageUrl?: string;
}

export interface PlpFilterItemVm {
  name: string;
  displayName: string;
  count: number;
  url: string;
  selected: boolean;
}

export interface PlpFilterVm {
  category: string;
  items: PlpFilterItemVm[];
}

export interface ProductListingVm {
  header: string;
  totalCount: number;
  filters: PlpFilterVm[];
  designs: PlpDesignItemVm[];
  redirectUrl?: string;
  filtersResetUrl?: string;
  listingSeo?: ListingSeo;
  faqs?: ListingFaqItem[];
}

export function toPlpDesignItemVm(item: PlpDesignItem): PlpDesignItemVm {
  return {
    designId: item.designId,
    designName: item.designName,
    imageUrl: item.imageUrl,
    ...(item.hoverImageUrl != null ? { hoverImageUrl: item.hoverImageUrl } : {}),
    productPageUrl: item.productPageUrl,
    price: item.price,
    discountedPrice: item.discountedPrice,
    discountPercent: item.discountPercent,
    discountOnDiamondPriceValue: item.discountOnDiamondPriceValue,
    ...(item.discountName != null ? { discountName: item.discountName } : {}),
    ...(item.discountValue != null ? { discountValue: item.discountValue } : {}),
    ...(item.customizationId != null ? { customizationId: item.customizationId } : {}),
    ...(item.videoUrl != null ? { videoUrl: item.videoUrl } : {}),
    ...(item.videoPosterUrl != null ? { videoPosterUrl: item.videoPosterUrl } : {}),
    ...(item.categoryType != null ? { categoryType: item.categoryType } : {}),
    ...(item.metal != null ? { metal: item.metal } : {}),
    ...(item.analyticsImageUrl != null ? { analyticsImageUrl: item.analyticsImageUrl } : {}),
  };
}

export function toPlpFilterItemVm(item: PlpFilterItem): PlpFilterItemVm {
  return {
    name: item.name,
    displayName: item.displayName,
    count: item.count,
    url: item.url,
    selected: item.selected,
  };
}

export function toPlpFilterVm(filter: PlpFilter): PlpFilterVm {
  return {
    category: filter.category,
    items: filter.items.map(toPlpFilterItemVm),
  };
}

export function toProductListingVm(listing: ProductListing): ProductListingVm {
  return {
    header: listing.header,
    totalCount: listing.totalCount,
    filters: listing.filters.map(toPlpFilterVm),
    designs: listing.designs.map(toPlpDesignItemVm),
    ...(listing.redirectUrl && { redirectUrl: listing.redirectUrl }),
    ...(listing.filtersResetUrl && { filtersResetUrl: listing.filtersResetUrl }),
    ...(listing.listingSeo && { listingSeo: listing.listingSeo as ProductListingVm['listingSeo'] }),
    ...(listing.faqs?.length && { faqs: listing.faqs }),
  };
}

